module.exports = __webpack_public_path__ + "img/maintenance.4365e558.svg";